<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/yyguKd/tc-custom/9780814350300.jpg?1724210189448" alt="This image is the cover for the book Science Fiction Theatre, TV Milestones"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Science Fiction Theatre, TV Milestones
      </h1>
      <p class="bookDescription body article font2">
        <p> <b>Embark on an odyssey through the series that galvanized the television sci-fi anthology genre.</b> </p><p>In the wake of the juvenile space operas of the early 1950s, a groundbreaking series debuted and paved the way for one of viewers' favorite genres today: adult-oriented science fiction. <i>Science Fiction Theatre</i> aired with a fresh anthology-style narrative from the vision of veteran producer Ivan Tors and with compelling narration by Truman Bradley. Created by industry-leading syndicator Ziv Television Programs, the show pioneered a scientifically based approach to aliens, telepathy, and the mysteries of the universe that provided a model for Rod Serling's The Twilight Zone (1959-64) and a myriad of acclaimed programs that followed, including The Outer Limits (1963-65), The Ray Bradbury Theater (1985-92),and Black Mirror (2011-present). This book contextualizes Science Fiction Theatre within the budding American television industry of the 1950s, as powerful networks and independent producers and syndicators vied to create and distribute programming to an audience eager to embrace this new, free medium. Including a complete videography of this historically neglected series, author J. P. Telotte illuminates Science Fiction Theatre as a touchstone for understanding the development of science fiction media and the dynamic nature of early television broadcasting.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        J. P. Telotte
      </h2>
      
      <p class="authorDescription body article"><p>J. P. Telotte is professor emeritus of film and media studies at the Georgia Institute of Technology, where he taught courses in film history, film genres, animation, and science fiction. He has also served as the coeditor of the journal <i>Post Script</i> and has published eighteen books on film and television with a special emphasis on science fiction media. He is the author of the earliest volume in the TV Milestones Series, <i>Disney TV</i> (Wayne State University Press), and is the editor of <i>The Oxford Handbook of New Science Fiction Cinemas.</i></p></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Wayne State University Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?1292de4a